import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const hubContactService = {};

// List HubDelivery
hubContactService.listHubContact = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/hub-contacts`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Create HubDelivery
hubContactService.createHubContact = data => {
  return fetchV2({
    url: `${env.API_MSP}/hub-contacts`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail HubDelivery
hubContactService.detailHubContact = ({
  hubContactId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/hub-contacts/${hubContactId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

// Update HubDelivery
hubContactService.updateHubContact = ({
  hubContactId = undefined,
  data = {},
}) => {
  return fetchV2({
    url: `${env.API_MSP}/hub-contacts/${hubContactId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete HubDelivery
hubContactService.deleteHubContact = (hubContactId = undefined) => {
  return fetchV2({
    url: `${env.API_MSP}/hub-contacts/${hubContactId}`,
    method: "delete",
  });
};

export default hubContactService;
